import { createSelector } from 'reselect'

export const getAdForPromo = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.promo && state.user.profile.promo.ad
    ? state.user.profile.promo.ad : null,
  ad => ad
)
